<script>
    export let message;
</script>

{#if message}
<div class={`sc__alert sc__alert--${message.type}`}>
    [{message.statusCode}] - {message.description}
</div>
{/if}